module.exports = '<svg width="192" height="32" viewBox="0 0 192 32"><path d="M184 32H8c-4.416 0-8-3.584-8-8V8c0-4.416 3.584-8 8-8h176c4.416 0 8 3.584 8 8v16c0 4.416-3.584 8-8 8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/minus-1.js
// module id = 1282
// module chunks = 14